"use strict";

/* -----------------------------------
MODULES
------------------------------------ */
import { WIN_WIDTH, SCROLL_TOP } from "./modules/_utils.js";
import inview from "./modules/_inview.js";
import lineButton from "./modules/_lineButton.js";
import header from "./modules/_header.js";
import footer from "./modules/_footer.js";
import intro from "./modules/_intro.js";
import _about from "./modules/_about.js";
window.addEventListener('DOMContentLoaded', function () {
  var mainID = document.querySelector('main').id;
  var pageFunc = {
    common: function common() {
      inview();
      lineButton();
      header();
      footer();
    },
    top: function top() {
      intro();
    },
    about: function about() {
      _about();
    },
    business: function business() {},
    recruit: function recruit() {},
    contact: function contact() {}
  };
  switch (mainID) {
    case 'top':
      pageFunc.top();
      break;
    case 'about':
      pageFunc.about();
      break;
    case 'business':
      pageFunc.business();
      break;
    case 'recruit':
      pageFunc.recruit();
      break;
    case 'contact':
      pageFunc.contact();
      break;
    default:
      break;
  }
  pageFunc.common();
});